import ViewWrapper from 'components/view-wrapper/view-wrapper.vue';
import InnerFrame from 'components/inner-frame/inner-frame';
import RouteBuilder from './routeBuilder';
import { otpHost } from './../config/env.conf';
const bizLine = 'gty';
const baseUrl = `${otpHost}/#/${bizLine}/`;
const productPrefix = `${baseUrl}product/`;
const orderPrefix = `${baseUrl}order/`;
const gtyBuiler = new RouteBuilder(bizLine, ViewWrapper, InnerFrame);
let financeInfo = RouteBuilder.buildFinanceInfo(gtyBuiler);
//
import OperatingData from 'views/dataPlatform/operateData/Main.vue';
import ProductData from 'views/dataPlatform/productData/Main.vue';
import ServeData from 'views/dataPlatform/serviceData/Main.vue'
let dataSummaryInfo = RouteBuilder.buildDataSummary(gtyBuiler, OperatingData, ProductData, ServeData);
let promotionInfo = RouteBuilder.buildPromotionInfo(gtyBuiler);
import Comment from 'views/comment/list/Main.vue';
let reviewList = RouteBuilder.buildReviewList(gtyBuiler, Comment);
let commentDetail = RouteBuilder.buildReviewDetail(gtyBuiler, Comment);
let qaManagement = RouteBuilder.buildQaA(gtyBuiler);
import AcademyHome from 'views/academy/HomePage.vue';
let xgxy = RouteBuilder.buildXAXY(gtyBuiler, AcademyHome);
let gzzx = RouteBuilder.buildGZZX(gtyBuiler);

function getBizName(name) {
    return bizLine + name;
}

export default [{
    name: getBizName('home'),
    path: '',
    component: require('components/nhomepage/nhomepage.vue'),
    meta: {
        title: '首页',
        icon: 'turbo-ui-home',
        bizLineId: 3
    }
}, {
    name: getBizName('product'),
    path: 'product',
    component: InnerFrame,
    meta: {
        title: '产品管理',
        icon: 'turbo-ui-setting'
    },
    children: [{
        name: getBizName('productNew'),
        path: 'detail',
        component: InnerFrame,
        meta: {
            title: '添加新产品',
            src: `${productPrefix}item/detail/?tab=0'`
        }
    }, {
        name: getBizName('productList'),
        path: 'list',
        component: InnerFrame,
        meta: {
            title: '产品查询',
            src: productPrefix + 'product-list'
        }
    }, {
        name: getBizName('productOnlineList'),
        path: 'onlineList',
        component: InnerFrame,
        meta: {
            title: '已上线查询',
            src: `${productPrefix}product-online?status=online`
        }
    }, {
        name: getBizName('productReadyList'),
        path: 'readyList',
        component: InnerFrame,
        meta: {
            title: '未上线查询',
            src: `${productPrefix}product-ready?status=ready`
        }
    },
    {
        name: getBizName('productOfflineList'),
        path: 'offlineList',
        meta: {
            title: '已下线查询',
            src: `${productPrefix}product-offline?status=offline`
        }
    },
    {
        name: getBizName('productCancelList'),
        path: 'cancelList',
        component: InnerFrame,
        meta: {
            title: '取消团期',
            src: `${productPrefix}product-cancel`
        }
    }
    ]
}, {
    name: getBizName('order'),
    path: 'order',
    component: ViewWrapper,
    meta: {
        title: '订单管理',
        icon: 'assignment'
    },
    children: [{
        name: getBizName('orderlist'),
        path: 'list',
        component: InnerFrame,
        meta: {
            title: '订单查询',
            src: orderPrefix + 'gty-list-order'
        }
    },
    {
        name: getBizName('orderConfirmList'),
        path: 'confirmlist',
        component: InnerFrame,
        meta: {
            title: '待确认订单',
            src: orderPrefix + 'gty-confirm-order?defaultStatus=1'
        }
    },
    {
        name: getBizName('nopayOrderList'),
        path: 'nopayorderlist',
        component: InnerFrame,
        meta: {
            title: '未付款订单',
            src: orderPrefix + 'gty-list-workorder'
        }
    }
    ]
}, financeInfo, dataSummaryInfo, promotionInfo, reviewList, commentDetail, qaManagement, xgxy, gzzx];


// WEBPACK FOOTER //
// ./src/router/router.gty.js